import { InputAndDateFilter, ISiteSketchesFilterOptions, ISiteSketchesResponse } from "@/types/SitesSketches";
import { service } from "./api";
import { IUIConfigState } from "@/types/common";
interface SketchDateRangeFilter {
  fromDate?: string;
  toDate?: string;
}

export const siteSketchesService = {
  getSketchesList: (filter: InputAndDateFilter) => service.post<ISiteSketchesResponse>("/customers/site-sketch/search", filter, undefined, false)
};

export const siteSkectchNumberStatus = {
  getNumberStatus: () => service.get("/customers/site-sketch/count-by-status")
};

export const siteSkectchFilter = {
  getSiteSkectchFilter: (filter: SketchDateRangeFilter) =>
    service.get<ISiteSketchesFilterOptions>(`/customers/site-sketch/filters?fromDate=${filter.fromDate}&toDate=${filter.toDate}`)
};

export const siteSketchUiConfig = {
  getSiteSketchUiConfig: () => service.get("/uiConfigs/SiteSketch"),
  updateUiConfig: (params: IUIConfigState) => service.put<IUIConfigState>("/uiConfigs", params)
};
